  /* ---------- shared chrome ---------- */
  const FT_COPY_ICON =
    '<svg viewBox="0 0 14 14" aria-hidden="true">' +
    '<rect x="4.5" y="4.5" width="8" height="8" fill="none" stroke="currentColor"/>' +
    '<path d="M9.5 1.5 h -8 v 8" fill="none" stroke="currentColor"/></svg>';
  const FT_COPIED_ICON =
    '<svg viewBox="0 0 14 14" aria-hidden="true">' +
    '<path d="M2.5 7.5 L 6 11 L 11.5 3.5" fill="none" stroke="currentColor"/></svg>';

  function renderChrome() {
    const ft = document.getElementById('site-footer');
    if (!ft) return;
    /* the stage is built on the landing alone; elsewhere the footer stands
       where it falls */
    if (document.getElementById('designers') && isDesktop() && !ft.parentElement.classList.contains('ft-stage')) {
      const stage = document.createElement('div');
      stage.className = 'ft-stage';
      ft.parentNode.insertBefore(stage, ft);
      stage.appendChild(ft);
      document.body.classList.add('ft-rise');
      wireRiseFx(stage);
    }
    document.body.dataset.ft = 'map-right';
    ft.innerHTML = ftMapRightHTML();
    wireFtCopy(ft);
    initFtMap();
  }

/* markup builders: future Liquid */

  const FT_ADDR_EN = setting('address_en', '19 Jandari-ro 3-gil, Mapo-gu, Seoul');
  const FT_ADDR_KR = setting('address_kr', '서울 마포구 잔다리로3길 19');
  /* the parcel alone for map queries: a floor confuses a geocoder */
  const FT_ADDR_GEO = FT_ADDR_KR;

  function ftAddrRowHTML(line, cls) {
    /* the copy glyph is tied to the line's last word so it cannot wrap alone */
    const cut = line.lastIndexOf(' ');
    const head = cut < 0 ? '' : line.slice(0, cut + 1);
    const tail = cut < 0 ? line : line.slice(cut + 1);
    return '<span class="ft-addr-row' + (cls ? ' ' + cls : '') + '">' + head +
      '<span class="ft-tie">' + tail +
      '<button class="ft-copy" type="button" aria-label="copy address"' +
      ' title="copy address" data-copy="' + line + '">' + FT_COPY_ICON + '</button></span></span>';
  }
  function ftAddrHTML() {
    return '<div class="ft-addr">' +
      ftAddrRowHTML(FT_ADDR_EN) + ftAddrRowHTML(FT_ADDR_KR, 'ft-addr-kr') + '</div>';
  }
  function ftHoursHTML() {
    const open = setting('hours_days', 'thu fri sat sun').toLowerCase().split(/\s+/);
    const days = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];
    const onDays = days.filter(function (d) { return open.indexOf(d) >= 0; });
    return '<div class="ft-days" role="img" aria-label="open ' + esc(onDays.join(', ')) + '">' +
      days.map(function (d) {
        return '<span class="ft-day' + (open.indexOf(d) >= 0 ? ' on' : '') + '">' + d + '</span>';
      }).join('') + '</div>' +
      '<p class="ft-line">' + esc(setting('hours_time', '12:00 pm – 8:00 pm')) + '</p>';
  }
  const FT_IG_ICON =
    '<svg viewBox="0 0 16 16" aria-hidden="true">' +
    '<rect x="1.6" y="1.6" width="12.8" height="12.8" rx="3.6" fill="none" stroke="currentColor"/>' +
    '<circle cx="8" cy="8" r="3.2" fill="none" stroke="currentColor"/>' +
    '<circle cx="11.9" cy="4.1" r="0.9" fill="currentColor"/></svg>';
  /* one order wherever the four stand: the legal register's own */
  function ftLinksHTML() {
    /* contact opens a letter rather than the page */
    return '<a class="ft-sm" href="' + ROUTES.legal + '#shipping">shipping &amp; returns</a>' +
      '<a class="ft-sm" href="' + ROUTES.legal + '#terms">terms</a>' +
      '<a class="ft-sm" href="' + ROUTES.legal + '#privacy">privacy policy</a>' +
      '<a class="ft-sm" href="mailto:' + esc(setting('contact_email', 'info@turiya.kr')) + '">contact</a>';
  }
  function ftIgHTML() {
    const href = setting('instagram_url', '#');
    return '<a class="ft-ig" href="' + esc(href) + '" aria-label="instagram"' +
      (href === '#' ? '' : ' target="_blank" rel="noopener"') + '>' + FT_IG_ICON + '</a>';
  }
  /* the ground while the live map loads; the map fades in over it, so a fast
     scroll meets stillness, never a swap */
  function ftMapHTML() {
    return '<div class="ft-map" role="img" aria-label="map: turiya at 19, jandari-ro 3-gil">' +
      '<span class="mp-wait" aria-hidden="true">37.55° n · 126.92° e</span></div>';
  }

  /* ---------- the map ----------
     hl=en holds the map's labels in English whatever the browser asks; the
     outward link carries no hl on purpose, since past Google the reader's own
     language preference is theirs */
  function initFtMap() {
    const host = document.querySelector('.ft-map');
    if (!host || host.querySelector('.ft-map-embed')) return;
    /* built at idle, not lazily: loading=lazy put the tile fetch exactly under
       the reader's scroll into the footer */
    const buildEmbed = function () {
      const frame = document.createElement('iframe');
      frame.className = 'ft-map-embed';
      frame.title = 'map: turiya, jandari-ro 3-gil 19';
      /* no-referrer-when-downgrade sent Google the whole page address, so which
         work a reader was looking at travelled with their IP */
      frame.referrerPolicy = 'no-referrer';
      frame.src = 'https://www.google.com/maps?q=' + encodeURIComponent(FT_ADDR_GEO) +
        '&z=16&hl=en&output=embed';
      frame.addEventListener('load', function () { frame.classList.add('up'); });
      host.appendChild(frame);
      /* the pressed embed's chrome is clipped away, so the whole tile is one
         door to the real map and the frame stands down from the pointer */
      const out = document.createElement('a');
      out.className = 'ft-map-out';
      out.href = 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(FT_ADDR_GEO);
      out.target = '_blank';
      out.rel = 'noopener';
      out.setAttribute('aria-label', 'open in google maps: turiya, jandari-ro 3-gil 19');
      host.appendChild(out);
    };
    (window.requestIdleCallback || function (f) { setTimeout(f, 1200); })(buildEmbed);
  }
  /* the seller's registration, asked for by Korean e-commerce law. This block
     cannot become conditional: the legal sheet points here rather than
     restating the numbers, so hiding it on any page makes that page's terms
     cite something the reader cannot see. */
  function ftBizHTML() {
    /* the order is shared with the shop policies and the notification emails,
       so changing it here changes one place of three */
    const regNo = setting('biz_reg_no', '');
    const phone = setting('biz_phone', '');
    const email = setting('contact_email', '');
    /* [label, value, held whole, href]: a door names its href here rather than
       being recognised by its text below */
    const parts = [
      ['\uc0c1\ud638', setting('biz_name', '')],
      ['\ub300\ud45c\uc790', setting('biz_rep', '')],
      ['\uc0ac\uc5c5\uc790\ub4f1\ub85d\ubc88\ud638', regNo, true,
        regNo ? 'http://www.ftc.go.kr/bizCommPop.do?wrkr_no=' + regNo.replace(/\D/g, '') : ''],
      ['\ud1b5\uc2e0\ud310\ub9e4\uc5c5\uc2e0\uace0', setting('biz_mail_order_no', ''), true],
      /* the last three stand bare: the law's disclosure lists the email, and the
         labels were the only part not saying anything */
      ['', setting('biz_addr', '')],
      /* dialable and writable values are links, or a mobile browser makes them
         links itself in its own blue */
      ['', phone, true, phone ? 'tel:' + phone.replace(/[^\d+]/g, '') : ''],
      ['', email, false, email ? 'mailto:' + email : '']
    ].filter(function (p) { return p[1]; });
    if (!parts.length) return '';
    return '<p class="ft-biz">' + parts.map(function (p) {
      let v = esc(p[1]);
      if (p[3]) {
        const away = p[3].indexOf('http') === 0;
        v = '<a class="ft-biz-link" href="' + esc(p[3]) + '"' +
          (away ? ' target="_blank" rel="noopener"' : '') + '>' + v + '</a>';
      }
      /* a span rather than a non-breaking hyphen, which would travel with a
         copy and paste as a character a form rejects */
      if (p[2]) v = '<span class="ft-whole">' + v + '</span>';
      return (p[0] ? p[0] + ' ' : '') + v;
    }).join(' \u00b7 ') + '</p>';
  }
  function ftBaseHTML() {
    return ftBizHTML() + '<div class="ft-base">' +
      '<a class="ft-credit" href="' + esc(setting('credit_url', 'https://linktr.ee/wanu')) + '" target="_blank" rel="noopener">' +
      esc(setting('credit_label', 'site credit')) + '</a>' +
      '<span>© 2026 TURIYA. All Rights Reserved.</span></div>';
  }

  function ftMapRightHTML() {
    /* the wrappers let the phone lay a true two-row grid; on desktop they stand
       down to display: contents */
    return '<div class="ft-mr">' +
      '<div class="ft-mr-rail">' +
      '<div class="ft-grp ft-grp-space"><p class="ft-h">the space</p>' + ftAddrHTML() + '</div>' +
      '<div class="ft-grp ft-grp-hours"><p class="ft-h ft-h-2">hours</p>' + ftHoursHTML() + '</div>' +
      '<div class="ft-grp ft-grp-links"><p class="ft-h ft-h-2">turiya</p>' + ftLinksHTML() + '</div>' +
      '<div class="ft-grp ft-grp-social"><p class="ft-h ft-h-2">socials</p>' + ftIgHTML() + '</div>' +
      '</div>' + ftMapHTML() +
      '</div>' + ftBaseHTML();
  }

  /* --rise carries the sheet's progress; dzNudge tells the register when it is
     under the sheet, which it cannot see for itself */
  function wireRiseFx(stage) {
    /* the register is the only element the sheet's progress is read on
       (assets/footer.css), and it stands outside the stage, so it carries it */
    const dz = document.getElementById('designers');
    function rise() {
      const r = stage.getBoundingClientRect();
      const p = Math.min(1, Math.max(0, (window.innerHeight - r.top) / (window.innerHeight * 0.75)));
      dz.style.setProperty('--rise', p.toFixed(3));
      return p;
    }
    function readRise() {
      /* the nudge speaks only to a reader who can see the register */
      if (typeof dzNudge === 'function') dzNudge(rise() < 0.15);
    }
    /* one read a frame: unbatched, every scroll event forced its own layout */
    let queued = false;
    window.addEventListener('scroll', function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; readRise(); });
    }, { passive: true });
    /* a frame late, so the page has its height: read at wiring it measured the
       footer against unsized stages and published a false half-rise */
    requestAnimationFrame(readRise);
  }

/* wiring: ports as-is */

  function wireFtCopy(ft) {
    ft.querySelectorAll('.ft-copy').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const text = btn.getAttribute('data-copy');
        const done = function () {
          btn.innerHTML = FT_COPIED_ICON;
          setTimeout(function () { btn.innerHTML = FT_COPY_ICON; }, 1200);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(text).then(done, done);
          return;
        }
        const ta = document.createElement('textarea');
        ta.value = text;
        document.body.appendChild(ta);
        ta.select();
        try { document.execCommand('copy'); } catch (e) { /* nothing to do */ }
        ta.remove();
        done();
      });
    });
  }
